module.exports = __webpack_public_path__ + "img/image2.fe9547b2.jpg";